import React from "react";
import { MenuItem } from "react-pro-sidebar";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

const SidebarMenuItem = ({ 
  title, 
  icon, 
  onClick, 
  selected, 
  setSelected,
  badge,
  isNew,
  itemKey  // New prop for key-based selection
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const keyToCompare = itemKey || title;
  const isSelected = selected === keyToCompare;

  return (
    <MenuItem
      active={isSelected}
      style={{
        color: isSelected ? colors.blueAccent[300] : colors.grey[200],
        backgroundColor: isSelected ? `${colors.blueAccent[800]}40` : 'transparent',
        borderLeft: isSelected ? `4px solid ${colors.blueAccent[400]}` : '4px solid transparent',
        margin: '4px 8px',
        borderRadius: '12px',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'visible'
      }}
      onClick={() => {
        setSelected(keyToCompare);
        onClick();
      }}
      icon={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 36,
            height: 36,
            borderRadius: '10px',
            backgroundColor: isSelected 
              ? `${colors.blueAccent[500]}20` 
              : 'transparent',
            color: isSelected ? colors.blueAccent[300] : colors.grey[300],
            transition: 'all 0.3s ease',
            '& svg': {
              fontSize: '20px',
            }
          }}
        >
          {icon}
        </Box>
      }
    >
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <Typography
          variant="body1"
          fontWeight={isSelected ? 700 : 500}
          sx={{
            fontSize: '0.95rem',
            letterSpacing: '0.3px'
          }}
        >
          {title}
        </Typography>
        
        {/* Badge for notifications */}
        {badge && (
          <Box
            sx={{
              minWidth: 20,
              height: 20,
              borderRadius: '10px',
              backgroundColor: colors.redAccent[500],
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.7rem',
              fontWeight: 700,
              px: 0.5,
              boxShadow: `0 2px 8px ${colors.redAccent[500]}60`
            }}
          >
            {badge}
          </Box>
        )}

        {/* "New" indicator */}
        {isNew && (
          <Box
            sx={{
              px: 1,
              py: 0.3,
              borderRadius: '8px',
              backgroundColor: colors.greenAccent[600],
              color: 'white',
              fontSize: '0.65rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              boxShadow: `0 2px 8px ${colors.greenAccent[600]}60`
            }}
          >
            New
          </Box>
        )}
      </Box>
    </MenuItem>
  );
};

export default SidebarMenuItem;






